import { KanbanPusherAddCard, KanbanPusherAddLane, KanbanPusherDeleteCard, KanbanPusherMoveCard, KanbanPusherUpdateDocument } from "./kanbanPusherTypes";

export const validateKanbanPusherMoveCard = (data: KanbanPusherMoveCard) => {
    if(!data.userId) return false
    if(!data?.data?.docId) return false
    
    if(data?.data?.sourceLane !== parseInt(data?.data?.sourceLane) + '') return false
    if(data?.data?.targetLane !== parseInt(data?.data?.targetLane) + '') return false
    
    return true
}

export const validateKanbanPusherAddCard = (data: KanbanPusherAddCard) => {
    try {
        if(!data.userId) return false
        if(!data?.data?.documentId) return false
        
        if(!('order' in data.data)) return false
        if(!('list' in data.data)) return false
        
        return true
    } catch (error) {
        return false       
    }
}

export const validateKanbanPusherDeleteCard = (data: KanbanPusherDeleteCard) => {
    try {
        if(!data.userId) return false
        if(!data?.data?.documentId) return false
        
        return true
    } catch (error) {
        return false       
    }
}
export const validateKanbanPusherUpdateDocument = (data: KanbanPusherUpdateDocument) => {
    try {
        if(!data.userId) return false
        if(!data?.data?.documentId) return false
        
        return true
    } catch (error) {
        return false       
    }
}

export const validateKanbanPusherAddLane = (data: KanbanPusherAddLane) => {
    try {
        if(!data.userId) return false
        if(!data?.data?.id) return false
        if(!data?.data?.title) return false
        if(!data?.data?.order && data.data.order !== 0) return false
        if(!data?.data?.listColor && data.data.listColor !== 0) return false

        return true
    } catch (error) {
        
        return false       
    }
}